import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../../styles/emotion';

import { LinkV2 } from '../../LinkV2';

export const StyledBackLink = styled(LinkV2)`
  display: flex;
  justify-content: center;
  position: absolute;
  top: ${SPACING.S24};
  left: ${SPACING.S24};
`;

export const StepCount = styled.div`
  margin-bottom: ${SPACING.LG};
  color: ${COLORS3.BLACK_075};
  ${FONT.textSizeUltraCompact(FONT.SIZE.SMALL)}
  ${MEDIA_QUERY.MOBILE} {
    margin-bottom: ${SPACING.S16};
  }
`;
